import { render, staticRenderFns } from "./groupMember.vue?vue&type=template&id=1db06ef2&scoped=true"
import script from "./groupMember.vue?vue&type=script&lang=js"
export * from "./groupMember.vue?vue&type=script&lang=js"
import style0 from "./groupMember.vue?vue&type=style&index=0&id=1db06ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db06ef2",
  null
  
)

export default component.exports